// calculates the sum of the UTF-8 byte values of the characters in the string
function utf8StringSum(str: string): number {
  return [...str].reduce((acc, char) => acc + char.charCodeAt(0), 0);
}

function avatarBackgroundColor(id: string): string {
  const colors = ['#D1DFF2', '#F1EFD3', '#DCE7DF', '#F8D6C5', '#E5D8E9'];
  const index = utf8StringSum(id) % colors.length;
  return colors[index] ?? '#D1DFF2';
}

function avatarForegroundColor(id: string): string {
  const colors = ['#2D5288', '#8C873B', '#507259', '#AA3F1B', '#65386B'];
  const index = utf8StringSum(id) % colors.length;
  return colors[index] ?? '#2D5288';
}

export function getAvatarColors(id: string): { background: string; foreground: string } {
  return {
    background: avatarBackgroundColor(id),
    foreground: avatarForegroundColor(id),
  };
}
